import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import appUrls from '../appUrls';
import ChangePasswordPage from '../pages/auth/change-password';

import LogoutPage from '../pages/auth/logout';
import ContactUsPage from '../pages/contact';
import QuestionsPage from '../pages/questions';
import GalleryPage from '../pages/gallery';
import TestimonialPage from '../pages/testimonial';
import RequestedTestimonialPage from '../pages/requestedTestimonial';
import CollagePage from '../pages/collage';
import PollQuestionsPage from '../pages/poll-questions';
import UserProfileEditPage from '../pages/auth/profile/edit';
import UserProfileViewPage from '../pages/auth/profile/view';
import StudentPage from '../views/students/list';
import CommonPageData from 'views/CommonPageData/list';
import CommonPageDataEdit from 'views/CommonPageData/edit';

// dashboard routing
const DashboardPage = Loadable(lazy(() => import('pages/dashboard')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: appUrls.LOGOUT,
            element: <LogoutPage />,
            include: 'common'
        },
        {
            path: appUrls.DASHBOARD,
            element: <DashboardPage />,
            include: 'common'
        },
        {
            path: appUrls.STUDENT,
            element: <StudentPage />,
            include: 'studentList'
        },
        {
            path: appUrls.COMMON_PAGE_DATA,
            element: <CommonPageData />,
            include: 'commonPageData'
        },
        {
            path: appUrls.COMMON_PAGE_DATA_EDIT,
            element: <CommonPageDataEdit />,
            include: 'commonPageData'
        },
        {
            path: appUrls.CHANGE_PASSWORD,
            element: <ChangePasswordPage />,
            include: 'common'
        },
        {
            path: appUrls.CONTACT,
            element: <ContactUsPage />,
            include: 'common'
        },
        {
            path: appUrls.QUESTIONS,
            element: <QuestionsPage />,
            include: 'profileQuestions'
        },
        {
            path: appUrls.POLL_QUESTIONS,
            element: <PollQuestionsPage />,
            include: 'includePoll'
        },
        {
            path: appUrls.GALLERY,
            element: <GalleryPage />,
            include: 'includeGallery'
        },
        {
            path: appUrls.TESTIMONIAL,
            element: <TestimonialPage />,
            include: 'includeTestimonials'
        },
        {
            path: appUrls.REQUEST_TESTIMONIAL,
            element: <RequestedTestimonialPage />,
            include: 'includeTestimonials'
        },
        {
            path: appUrls.COLLAGE,
            element: <CollagePage />,
            include: 'collagePhoto'
        },
        {
            path: appUrls.PROFILE,
            element: <UserProfileViewPage />,
            include: 'common'
        },
        {
            path: appUrls.PROFILE_EDIT,
            element: <UserProfileEditPage />,
            include: 'common'
        }
    ]
};

export default MainRoutes;
